import { escape, BRAND, buildSponsorStrip } from "./reelShared";

/**
 * LinkedIn / Instagram feed — 1080×1080 square.
 * More formal feel — reads as a professional statement post.
 */
export const buildLinkedinCardSVG = ({ user, color, tierShort, tierCap, memberNumber, sponsor }) => {
    const w = 1080;
    const h = 1080;
    const cx = w / 2;

    const metrics = [
        { label: "TREES RESTORED", value: user.trees_restored, color },
        { label: "LBS OCEAN PLASTIC", value: user.ocean_plastic_lbs, color: BRAND.ocean },
        { label: "BATTERIES PROTECTED", value: user.batteries_protected, color: BRAND.violet },
        { label: "CO₂ PREVENTED (LBS)", value: user.co2_saved_lbs.toLocaleString(), color: BRAND.solar },
    ];
    const metricsSvg = metrics
        .map((m, i) => {
            const col = i % 2;
            const row = Math.floor(i / 2);
            const x = col * 460;
            const y = row * 200;
            return `
    <g transform="translate(${x} ${y})">
      <rect x="0" y="0" width="440" height="180" rx="12" fill="#0a0a0a" stroke="${BRAND.line}"/>
      <circle cx="24" cy="28" r="5" fill="${m.color}"/>
      <text x="38" y="34" fill="${BRAND.inkDim}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="14" font-weight="700" letter-spacing="4">${escape(m.label)}</text>
      <text x="24" y="130" fill="${BRAND.ink}" font-family="'Menlo', 'Courier New', monospace" font-size="60" font-weight="800">${escape(m.value)}</text>
    </g>`;
        })
        .join("");

    const sponsorSvg = sponsor ? buildSponsorStrip({ sponsor, cx, y: 980, color }) : "";
    const brandFooter = sponsor
        ? ""
        : `<text x="${cx}" y="1030" text-anchor="middle" fill="${BRAND.inkFaint}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="18" letter-spacing="6">POWERED BY THE EVIQ COMMUNITY · EVIQ.APP</text>`;

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" role="img" aria-label="EVIQ LinkedIn impact card">
  <defs>
    <linearGradient id="li-bg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="${BRAND.bgTop}"/>
      <stop offset="100%" stop-color="${BRAND.bgBottom}"/>
    </linearGradient>
    <radialGradient id="li-glow" cx="90%" cy="10%" r="70%">
      <stop offset="0%" stop-color="${color}" stop-opacity="0.22"/>
      <stop offset="100%" stop-color="${color}" stop-opacity="0"/>
    </radialGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="url(#li-bg)"/>
  <rect width="${w}" height="${h}" fill="url(#li-glow)"/>
  <rect x="1" y="1" width="${w - 2}" height="${h - 2}" fill="none" stroke="${BRAND.line}" stroke-width="2"/>

  <!-- Header -->
  <g transform="translate(80 80)">
    <rect x="0" y="0" width="48" height="48" rx="10" fill="#0a0a0a" stroke="#27272a"/>
    <path d="M 14 10 L 30 10 L 24 26 L 34 26 L 18 46 L 24 28 L 12 28 Z" fill="${color}"/>
    <text x="66" y="20" fill="${BRAND.inkDim}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="14" font-weight="700" letter-spacing="5">EVIQ</text>
    <text x="66" y="42" fill="${BRAND.ink}" font-family="Georgia, serif" font-style="italic" font-size="22">Earth Initiative</text>
  </g>

  <g transform="translate(${w - 80} 100)">
    <rect x="-220" y="-32" width="220" height="64" rx="32" fill="${color}" fill-opacity="0.14" stroke="${color}"/>
    <text x="-110" y="-6" text-anchor="middle" fill="${color}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="12" font-weight="700" letter-spacing="4">${escape(tierCap)}</text>
    <text x="-110" y="20" text-anchor="middle" fill="${color}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="18" font-weight="800" letter-spacing="3">${escape(tierShort)} #${escape(memberNumber)}</text>
  </g>

  <!-- Statement -->
  <text x="80" y="260" fill="${BRAND.ink}" font-family="Georgia, serif" font-size="60" font-weight="700">Driving with</text>
  <text x="80" y="330" fill="${BRAND.inkDim}" font-family="Georgia, serif" font-size="60" font-style="italic">measurable purpose.</text>
  <text x="80" y="390" fill="${BRAND.inkDim}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="20" letter-spacing="2">Every EVIQ membership quietly funds restoration.</text>

  <!-- Metrics -->
  <g transform="translate(80 470)">${metricsSvg}</g>

  ${sponsorSvg}
  ${brandFooter}
</svg>`;
};
